import _ from 'lodash';

const layoutPlacements = {
  '1COL_FULL_0':              '1col_full_0',
  '2COL_MID_MID_0':           '2col_mid_mid_0',
  '2COL_MID_MID_1':           '2col_mid_mid_1',
  '2COL_EXTRAWIDE_THIN_0':    '2col_extrawide_thin_0',
  '2COL_EXTRAWIDE_THIN_1':    '2col_extrawide_thin_1',
  '2COL_THIN_EXTRAWIDE_0':    '2col_thin_extrawide_0',
  '2COL_THIN_EXTRAWIDE_1':    '2col_thin_extrawide_1',
  '3COL_THIRD_THIRD_THIRD_0': '3col_third_third_third_0',
  '3COL_THIRD_THIRD_THIRD_1': '3col_third_third_third_1',
  '3COL_THIRD_THIRD_THIRD_2': '3col_third_third_third_2',
};

layoutPlacements.ALL = _.values(layoutPlacements);
layoutPlacements.NARROW = [
  layoutPlacements['2COL_EXTRAWIDE_THIN_1'],
  layoutPlacements['2COL_THIN_EXTRAWIDE_0'],
  layoutPlacements['3COL_THIRD_THIRD_THIRD_0'],
  layoutPlacements['3COL_THIRD_THIRD_THIRD_1'],
  layoutPlacements['3COL_THIRD_THIRD_THIRD_2'],
];
layoutPlacements.MID = [layoutPlacements['2COL_MID_MID_0'], layoutPlacements['2COL_MID_MID_1']];
layoutPlacements.WIDE = [
  layoutPlacements['1COL_FULL_0'],
  layoutPlacements['2COL_EXTRAWIDE_THIN_0'],
  layoutPlacements['2COL_THIN_EXTRAWIDE_1'],
];
layoutPlacements.FULL = [layoutPlacements['1COL_FULL_0']];
layoutPlacements.MID_WIDE = _.union(layoutPlacements.MID, layoutPlacements.WIDE);

export default layoutPlacements;
